<template>
    <div>
        <CRow class="content-fade-in">
            <CCol md="12">
                <CCard>
                    <CCardBody>
                        <CForm class="form-basic">
                            <CRow>
                                <CCol sm="12" md="12" xl="6">
                                    <BaseInput :options="titleInput.options" :data="titleInput.data" />
                                </CCol>
                                <CCol sm="12" md="12" xl="6">
                                    <BaseInput :options="versionInput.options" :data="versionInput.data" />
                                </CCol>
                                <CCol sm="12" md="12" xl="6">
                                    <BaseSelect :options="isSyncSelect.options" :data="isSyncSelect.data"
                                        ref="isSyncSelect"></BaseSelect>
                                </CCol>
                                <CCol sm="12" md="12" xl="6">
                                    <BaseSelect :options="isScheduleSummarySelect.options" :data="isScheduleSummarySelect.data"
                                        ref="isScheduleSummarySelect"></BaseSelect>
                                </CCol>
                                <CCol sm="12" md="12" xl="6">
                                    <BaseSelect :options="isCalcelAllOnStopSelect.options" :data="isCalcelAllOnStopSelect.data"
                                        ref="isCalcelAllOnStopSelect"></BaseSelect>
                                </CCol>
                                <CCol sm="12" md="12" xl="6">
                                    <BaseSelect :options="syncDeviceVersionSourceSelect.options" :data="syncDeviceVersionSourceSelect.data"
                                        ref="syncDeviceVersionSourceSelect"></BaseSelect>
                                </CCol>
                                <CCol sm="12" md="12" xl="6">
                                    <div class="form-group" :class="{
                                        'input-valid-error': locationInput.data.validator && !locationInput.data.validator.isValid,
                                        'no-label': !(locationInput.options && locationInput.options.label)
                                    }">
                                        <label v-html="locationInput.options.label"></label>
                                        <div>
                                            <input type="text" :placeholder="locationInput.options.placeholder"
                                                class="form-control" readonly v-model="locationInput.data.title"
                                                @click="chooseLocation()" ref="locationInput" />
                                            <div class="valid-error"
                                                v-show="!(locationInput.data.validator ? locationInput.data.validator.isValid : true)">
                                                {{ locationInput.data.validator ?
                                        locationInput.data.validator.errorMessage : "" }}
                                            </div>
                                        </div>
                                    </div>
                                </CCol>
                                <CCol sm="12" md="12" xl="6">
                                    <BaseInput :options="userNameInput.options" :data="userNameInput.data" />
                                </CCol>
                                <CCol sm="12" md="12" xl="6">
                                    <BaseInput :options="passwordInput.options" :data="passwordInput.data" />
                                </CCol>
                                <CCol sm="12" md="12" xl="6">
                                    <BaseInput :options="urlTokenInput.options" :data="urlTokenInput.data" />
                                </CCol>
                                <CCol sm="12" md="12" xl="6">
                                    <BaseInput :options="urlSyncDeviceInput.options" :data="urlSyncDeviceInput.data" />
                                </CCol>
                                <CCol sm="12" md="12" xl="6">
                                    <BaseInput :options="urlSyncHistoryInput.options"
                                        :data="urlSyncHistoryInput.data" />
                                </CCol>
                                <CCol sm="12" md="12" xl="6">
                                    <BaseInput :options="urlSyncScheduleInput.options"
                                        :data="urlSyncScheduleInput.data" />
                                </CCol>
                                <CCol sm="12" md="12" xl="6">
                                    <BaseInput :options="urlSyncCancelScheduleInput.options"
                                        :data="urlSyncCancelScheduleInput.data" />
                                </CCol>
                            </CRow>
                            <div slot="footer" class="mt-4">
                                <CButton color="primary" class="btn-action-primary mr-2" @click="submitData()">
                                    <i class="fa fa-save"></i>&nbsp;Lưu lại
                                </CButton>
                                <CButton color="secondary" class="btn-action-primary" @click="$router.go(-1)"><i
                                        class="fa fa-reply"></i>&nbsp;
                                    Hủy bỏ
                                </CButton>
                            </div>
                            <BaseLoading :loading="loading.value"></BaseLoading>
                        </CForm>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>

        <BaseLocationModal v-if="chooseLocationData.isShowModal" @item:selected="chooseLocationSelected($event)"
            @close-modal="closeModelChooseLocationId($event)"></BaseLocationModal>
    </div>
</template>

<script>
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseLoading from "@/views/base/BaseFormLoading";
import BaseTextArea from "@/views/base/BaseTextArea";
import BaseLocationModal from "@/views/base/BaseLocationModal";

export default {
    name: "ConfigSyncHtttnAdd",
    components: { BaseSelect, BaseInput, BaseLoading, BaseTextArea, BaseLocationModal },
    notifications: {
        showSuccessMsg: {
            type: "success",
            title: "Success"
        },
        showErrorMsg: {
            type: "error",
            title: "Errors"
        },
        showWarningMsg: {
            type: "warn",
            title: "warn"
        }
    },
    data: function () {
        let that = this;
        return {
            loading: { value: false },
            chooseLocationData: {
                isShowModal: false
            },
            isSyncSelect: {
                options: {
                    label: "Trạng thái <span class='required'>*</span>",
                    placeholder: "Trạng thái",
                    filter: false,
                },
                data: {
                    name: "sync",
                    items: [
                        { key: "1", value: "Đồng bộ" },
                        { key: "0", value: "Không đồng bộ" },
                    ],
                    model: "0",
                    updateCallback: function () {
                        that.submitData();
                    },
                }
            },
            isScheduleSummarySelect: {
                options: {
                    label: "Trạng thái đồng bộ lịch phát <span class='required'>*</span>",
                    placeholder: "Trạng thái đồng bộ lịch phát",
                    filter: false,
                },
                data: {
                    name: "isScheduleSummary",
                    items: [
                        { key: "1", value: "Đồng bộ tổng quát" },
                        { key: "0", value: "Đồng bộ chi tiết" },
                    ],
                    model: "0",
                    updateCallback: function () {
                        that.submitData();
                    },
                }
            },
            isCalcelAllOnStopSelect: {
                options: {
                    label: "Trạng thái dừng tất cả bản tin <span class='required'>*</span>",
                    placeholder: "Trạng thái dừng tất cả bản tin",
                    filter: false,
                },
                data: {
                    name: "isCalcelAllOnStop",
                    items: [
                        { key: "0", value: "Dừng toàn bộ bản tin hiện tại" },
                        { key: "1", value: "Hủy toàn bộ lịch" },
                    ],
                    model: "0",
                    updateCallback: function () {
                        that.submitData();
                    },
                }
            },
            syncDeviceVersionSourceSelect: {
                options: {
                    label: "Version đồng bộ thiết bị <span class='required'>*</span>",
                    placeholder: "Version đồng bộ thiết bị",
                    filter: false,
                },
                data: {
                    name: "syncDeviceVersionSource",
                    items: [
                        { key: "CONFIG", value: "Theo version cấu hình HTTTN" },
                        { key: "DEVICE", value: "Theo version thiết bị" },
                    ],
                    model: "CONFIG",
                    updateCallback: function () {
                        that.submitData();
                    },
                }
            },
            versionnput: {
                options: {
                    label: "Version <span class='required'>*</span>",
                    placeholder: "Version",
                    maxlength: 64
                },
                data: {
                    name: "version",
                    model: "",
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.versionnput.data.model;
                            if (value === "" || value.trim() === "") {
                                this.isValid = false;
                                this.errorMessage = "Version không được để trống";
                            } else {
                                this.isValid = true;
                            }
                            return this.isValid;
                        }
                    }
                }
            },
            titleInput: {
                options: {
                    label: "Tên cấu hình <span class='required'>*</span>",
                    placeholder: "Tên cấu hình",
                    maxlength: 256
                },
                data: {
                    name: "name",
                    model: "",
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.titleInput.data.model;
                            if (value === "" || value.trim() === "") {
                                this.isValid = false;
                                this.errorMessage = "Tên cấu hình không được để trống";
                            } else {
                                this.isValid = true;
                            }
                            return this.isValid;
                        }
                    }
                }
            },
            urlTokenInput: {
                options: {
                    label: "Url Token (DV001) <span class='required'>*</span>",
                    placeholder: "Url Token",
                    maxlength: 256
                },
                data: {
                    name: "urlToken",
                    model: "",
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.urlTokenInput.data.model;
                            if (value === "" || value.trim() === "") {
                                this.isValid = false;
                                this.errorMessage = "Url Token bản tin không được để trống";
                            } else {
                                this.isValid = true;
                            }
                            return this.isValid;
                        }
                    }
                }
            },
            urlSyncDeviceInput: {
                options: {
                    label: "Url Sync Device (DV008) <span class='required'>*</span>",
                    placeholder: "Url Sync Device",
                    maxlength: 256
                },
                data: {
                    name: "urlSyncDevice",
                    model: "",
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.urlSyncDeviceInput.data.model;
                            if (value === "" || value.trim() === "") {
                                this.isValid = false;
                                this.errorMessage = "Url Sync Device bản tin không được để trống";
                            } else {
                                this.isValid = true;
                            }
                            return this.isValid;
                        }
                    }
                }
            },
            urlSyncScheduleInput: {
                options: {
                    label: "Url Sync Schedule (DV006) <span class='required'>*</span>",
                    placeholder: "Url Sync Schedule",
                    maxlength: 256
                },
                data: {
                    name: "urlSyncSchedule",
                    model: "",
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.urlSyncScheduleInput.data.model;
                            if (value === "" || value.trim() === "") {
                                this.isValid = false;
                                this.errorMessage = "Url Sync Schedule không được để trống";
                            } else {
                                this.isValid = true;
                            }
                            return this.isValid;
                        }
                    }
                }
            },
            urlSyncCancelScheduleInput: {
                options: {
                    label: "Url Sync Cancel Schedule (DV007) <span class='required'>*</span>",
                    placeholder: "Url Sync Cancel Schedule",
                    maxlength: 256
                },
                data: {
                    name: "urlSyncCancelSchedule",
                    model: "",
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.urlSyncCancelScheduleInput.data.model;
                            if (value === "" || value.trim() === "") {
                                this.isValid = false;
                                this.errorMessage = "Url Sync Cancel Schedule bản tin không được để trống";
                            } else {
                                this.isValid = true;
                            }
                            return this.isValid;
                        }
                    }
                }
            },
            urlSyncHistoryInput: {
                options: {
                    label: "Url Sync History (DV005) <span class='required'>*</span>",
                    placeholder: "Url Sync History",
                    maxlength: 256
                },
                data: {
                    name: "urlSyncHistory",
                    model: "",
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.urlSyncHistoryInput.data.model;
                            if (value === "" || value.trim() === "") {
                                this.isValid = false;
                                this.errorMessage = "Url Sync History không được để trống";
                            } else {
                                this.isValid = true;
                            }
                            return this.isValid;
                        }
                    }
                }
            },
            versionInput: {
                options: {
                    label: "Version <span class='required'>*</span>",
                    placeholder: "Version",
                    maxlength: 64
                },
                data: {
                    name: "version",
                    model: "",
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.versionInput.data.model;
                            if (value === "" || value.trim() === "") {
                                this.isValid = false;
                                this.errorMessage = "Version không được để trống";
                            } else {
                                this.isValid = true;
                            }
                            return this.isValid;
                        }
                    }
                }
            },
            userNameInput: {
                options: {
                    label: "Tài khoản <span class='required'>*</span>",
                    placeholder: "Tài khoản",
                    maxlength: 256
                },
                data: {
                    name: "userName",
                    model: "",
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.userNameInput.data.model;
                            if (value === "" || value.trim() === "") {
                                this.isValid = false;
                                this.errorMessage = "Tài khoản không được để trống";
                            } else {
                                this.isValid = true;
                            }
                            return this.isValid;
                        }
                    }
                }
            },
            passwordInput: {
                options: {
                    label: "Mật khẩu <span class='required'>*</span>",
                    placeholder: "Mật khẩu ",
                    type: "password",
                    maxlength: 256
                },
                data: {
                    name: "password",
                    model: "",
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.passwordInput.data.model;
                            if (value === "" || value.trim() === "") {
                                this.isValid = false;
                                this.errorMessage = "Mật khẩu không được để trống";
                            } else {
                                this.isValid = true;
                            }
                            return this.isValid;
                        }
                    }
                }
            },
            locationInput: {
                options: {
                    placeholder: "Chọn địa bàn",
                    label: "Địa bàn <span class='required'>*</span>"
                },
                data: {
                    name: "pathLocation",
                    model: "",
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.locationInput.data.model;
                            if (!value || value == '') {
                                this.isValid = false;
                                this.errorMessage = "Địa bàn không được để trống";
                            } else {
                                this.isValid = true;
                                this.errorMessage = "";
                            }
                            return this.isValid;
                        }
                    }
                }
            },
        }
    },
    methods: {
        chooseLocation() {
            this.chooseLocationData.isShowModal = true
        },

        submitData: function () {
            let that = this;
            let isValid = true;
            isValid &= this.userNameInput.data.validator.valid();
            isValid &= this.passwordInput.data.validator.valid();
            isValid &= this.titleInput.data.validator.valid();
            isValid &= this.urlSyncCancelScheduleInput.data.validator.valid();
            isValid &= this.urlSyncDeviceInput.data.validator.valid();
            isValid &= this.urlSyncHistoryInput.data.validator.valid();
            isValid &= this.urlSyncScheduleInput.data.validator.valid();
            isValid &= this.urlTokenInput.data.validator.valid();
            isValid &= this.locationInput.data.validator.valid();
            isValid &= this.versionInput.data.validator.valid();
            if (!isValid) {
                return;
            }
            let dataRequest = {
                userName: `${this.userNameInput.data.model}`,
                password: this.passwordInput.data.model,
                name: this.titleInput.data.model,
                urlSyncCancelSchedule: this.urlSyncCancelScheduleInput.data.model,
                urlSyncDevice: this.urlSyncDeviceInput.data.model,
                urlSyncHistory: this.urlSyncHistoryInput.data.model,
                urlSyncSchedule: this.urlSyncScheduleInput.data.model,
                urlToken: this.urlTokenInput.data.model,
                location: this.locationInput.data.model,
                isSync: this.isSyncSelect.data.model == 1 ? true : false,
                version: this.versionInput.data.model,
                syncDeviceVersionSource: this.syncDeviceVersionSourceSelect.data.model || "CONFIG",
                isScheduleSummary: this.isScheduleSummarySelect.data.model == 1 ? true : false,
                isCalcelAllOnStop: this.isCalcelAllOnStopSelect.data.model == "1" || this.isCalcelAllOnStopSelect.data.model == 1
            }
            this.$helper.loadDataSource({
                loading: that.loading,
                url: "/config-sync-htttn/create",
                dataSubmit: function () {
                    return dataRequest;
                },
                successCallback: function (response) {
                if (!that.$helper.validResponse(that.$router, response.data)) {
                    that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
                    that.$helper.setupErrorModel(response.data.data, that.$data);
                } else {
                    that.showSuccessMsg({
                        message: "Thêm mới cấu hình thành công"
                    });
                    that.$router.go(-1);
                }
                },
                errorCallback: function (error) {
                    that.$helper.handleError(that.$router, error);
                }
            });
        },

        closeModelChooseLocationId() {
            this.chooseLocationData.isShowModal = false
        },
        chooseLocationSelected(event) {
            this.locationInput.data.model = event.code;
            if (event.sourceId) {
                this.locationInput.data.title = event.code + ' - ' + event.name;
            } else {
                this.locationInput.data.title = event.name;
            }
            this.chooseLocationData.isShowModal = false;
        },
    },
    computed: {},
    created() {
    },
    mounted() {
    },
    watch: {}
}
</script>
<style></style>